import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";
import handleError from "@lib/helpers/handleError";
import buildListUrl from "@lib/shared/queryString";

export default function useFloats(page, sortBy, search, filters = {}) {
  const api = useAxios();

  const url = buildListUrl(
    "/floats",
    { page, sortBy: sortBy.property, sortDirection: sortBy.direction, search },
    filters
  );

  const { isPending, error, data, isPlaceholderData } = useQuery({
    queryKey: ["floats", page, sortBy, search, filters],
    queryFn: () => api.get(url),
    placeholderData: keepPreviousData,
  });

  handleError(error);

  const floats = data?.data.data ?? [];
  const lastPage = data?.data.meta.last_page ?? 0;
  const total = data?.data.meta.total ?? 0;
  const from = data?.data.meta.from ?? 0;
  const to = data?.data.meta.to ?? 0;
  const hasMore = (data?.data.meta.last_page > page ?? false) && !isPlaceholderData;

  return { floats, lastPage, total, from, to, hasMore, isLoading: isPending };
}
